<template>
  <Modal v-if="showModal" @close="closeModal">
    <Loading v-if="loading" />
    <div class="addSensorAlarmComment">
      <div class="addSensorAlarmComment__header">
        <span class="title">{{ $t('addAlarmComment') }}</span>
        <img
          src="@/assets/icons/CloseModal.svg"
          alt="Close Modal"
          @click="closeModal"
        />
      </div>
      <form id="sensorAlarmComment-form" @submit.prevent="save">
        <label class="label-comment" for="sensorAlarmComment">
          {{ $t('comment') }}
        </label>
        <textarea
          id="sensorAlarmComment"
          v-model="formData.alarmInfo"
          class="input-comment"
          maxlength="250"
        >
        </textarea>
      </form>
      <div class="addSensorAlarmComment__buttons">
        <Button variant="filled" :title="$t('save')" @click="save" />
        <Button variant="bordered" :title="$t('cancel')" @click="closeModal" />
      </div>
    </div>
  </Modal>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';

import Loading from '@/views/Loading.vue';

@Options({
  name: 'AddSensorAlarmComment',
  props: ['showModal', 'activeAlarm', 'loading'],
  emits: ['saveComment', 'closeModal'],
  components: {
    Loading
  },
  data() {
    return {
      formData: {
        alarmInfo: ''
      }
    };
  },
  methods: {
    save() {
      this.$emit('saveComment', this.formData.alarmInfo);
    },
    closeModal() {
      this.formData.alarmInfo = '';
      this.$emit('closeModal');
    }
  },
  watch: {
    showModal(value: boolean) {
      if (value) {
        this.formData.alarmInfo = '';
      }
    }
  }
})
export default class AddSensorAlarmComment extends Vue {}
</script>

<style lang="scss" scoped>
.addSensorAlarmComment {
  max-width: 400px;
  width: 100%;
  height: 100%;
  padding: 24px;
  .addSensorAlarmComment__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 23px;
    .title {
      font-family: 'Ubuntu-Medium';
      font-size: $eighteenSize;
      line-height: $fifteenSize;
    }
    img {
      cursor: pointer;
    }
  }
  #sensorAlarmComment-form {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 24px;
    width: 400px;
    height: 177px;
    label {
      position: absolute;
      font-family: 'Ubuntu-Regular';
      top: -6px;
      left: 15px;
      padding: 0 5px;
      background: $white;
      color: $label;
      font-weight: 400;
      font-size: $twelveSize;
      line-height: $fourteenSize;
      z-index: 1;
    }
    textarea {
      width: 366px;
      height: 140px;
      padding: 16px;
      font-size: $fourteenSize;
      border: 1px solid $border;
      border-radius: 8px;
      resize: none;
      &:focus {
        outline: none;
      }
    }
  }
  .addSensorAlarmComment__buttons {
    :first-child {
      margin-right: 12px;
    }
  }
}
</style>
